// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3Cx8M","checkboxCol":"Table_checkboxCol__27KAi","emailCol":"Table_emailCol__2av1f","actionCol":"Table_actionCol__1iiyM"};